import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/compound-interest',
  component: () => import('../../routes/CompoundInterest.svelte'),
  card: {
    id: 'compound-interest',
    title: 'Compound Interest',
    description: 'Visualize how your investments grow over time with the power of compounding returns.',
    icon: 'trending_up',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-primary',
    isPrimary: true,
    href: '/compound-interest',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Compound Interest Calculator – Investment & Stock Growth Calculator',
    description: 'Free compound interest calculator with monthly contributions. See how your investments grow with our financial calculator. Calculate compound interest rate for stocks, savings, and investments. Includes formula for compound interest explained.',
  },
};

export default meta;
